// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { ResourceValidationResultFragmentFragment } from '../../../../shared/graphql/fragments/generated/resource-validation-result.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ValidateCustomerForIstatQueryVariables = Types.Exact<{
  upsertCustomerDTO: Types.UpsertCustomerDtoInput;
}>;


export type ValidateCustomerForIstatQueryResult = { __typename?: 'Query', validateCustomerForIstat: Array<{ __typename?: 'ResourceValidationResultDTO', resourceId: number, validationErrors: Array<{ __typename?: 'ValidationErrorDTO', errorCode: string, fieldName: string | null, translationKey: string } | null> | null }> };

export const ValidateCustomerForIstatGql = gql`
    query ValidateCustomerForIstat($upsertCustomerDTO: UpsertCustomerDTOInput!) {
  validateCustomerForIstat(upsertCustomerDTO: $upsertCustomerDTO) {
    ...ResourceValidationResultFragment
  }
}
    ${ResourceValidationResultFragmentFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ValidateCustomerForIstatInjectable extends Apollo.Query<ValidateCustomerForIstatQueryResult, ValidateCustomerForIstatQueryVariables> {
    override document = ValidateCustomerForIstatGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */